import { render } from "./CreacionClientesRecomendados.vue?vue&type=template&id=036fd5a9"
import script from "./CreacionClientesRecomendados.vue?vue&type=script&lang=js"
export * from "./CreacionClientesRecomendados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__